// Classifies a classic pattern's `key_points` names (backend `PatternMatchModel.key_points`
// JSON, e.g. {"first_bottom": 0, "peak_1": 5, ...}) into structural highs vs lows, so a
// chart can mark each with the right triangle orientation (▼ above a peak, ▲ below a
// trough) regardless of pattern type. Shared between PatternDetail's full detail chart and
// the homepage's compact "Reporting Soon" signal chart (HomeEarningsSignals) so both use
// the same visual vocabulary for the same point names. A handful of "event" points
// (breakout/breakdown/neckline_break and similar) are neither and are left unclassified —
// callers should skip anything not in either set rather than guess an orientation for it.

export const PEAK_KEY_POINTS = new Set([
  'head', 'left_shoulder', 'right_shoulder',
  'left_peak', 'right_peak',
  'first_peak', 'second_peak', 'third_peak', 'peak_1', 'peak_2',
  'arch_top', 'handle_peak', 'top',
  'pole_top', 'flag_high', 'pennant_high_1', 'pennant_high_2',
  'first_high', 'second_high', 'third_high',
]);

export const TROUGH_KEY_POINTS = new Set([
  'left_trough', 'right_trough',
  'first_bottom', 'second_bottom', 'third_bottom',
  'cup_bottom', 'handle_dip', 'bottom',
  'valley', 'valley_1', 'valley_2',
  'pole_bottom', 'flag_low', 'pennant_low_1', 'pennant_low_2',
  'first_low', 'second_low', 'third_low',
]);
